import AccountScreen from "../AccountScreen.js";
export default {
  id: 'account.Route',
  exact: false,
  path: '/account',
  matches: {
    client: 'Main'
  },
  component: AccountScreen
};